<!-- Display Mode -->
@if (!editMode) {
  <div
    fxLayout="column"
    class="box is-elevation-4">
    <div
      fxLayout="row"
      fxLayoutAlign="start center"
      class="tts-header">
      <div
        class="tts-header-number"
        fxLayout="row"
        fxLayoutAlign="center center">
        {{ index + 1 }}
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="start center"
        class="ml-3">
        <i class="icon icon-arrow-undo tts-header-icon"></i>
        <div class="tts-header-text">{{ 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-13' | translate }}</div>
      </div>
    </div>
    <div
      class="tts-body"
      fxLayout="column"
      fxLayoutAlign="start">
      <div class="explain-confirm-desc">{{ 'COMMUNICATIONS.DESIGNER.TTS-CONFIRM-MESSAGE-DESC' | translate }}</div>
      <div class="explain-confirm-text">
        {{ 'COMMUNICATIONS.DESIGNER.TTS-CONFIRM-MESSAGE-TEXT' | translate }}
      </div>
      @for (confirmationButton of confirmationButtons; track confirmationButton.uId) {
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="4px">
          <div
            fxLayout="row"
            fxLayoutAlign="center center"
        [ngClass]="{
          'confirmation-button': true,
          'yes-button': confirmationButton?.type === ConfirmationType.Positive,
          'no-button': confirmationButton?.type !== ConfirmationType.Positive
        }">
            {{ confirmationButton.index }}
          </div>
          <div>{{ confirmationButton.text }}</div>
        </div>
      }
    </div>
  </div>
}

<!-- Edit Settings -->
@if (editMode) {
  <div></div>
}
